// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3qCIa","colMin":"styles_colMin__3x9Qq","colCheckbox":"styles_colCheckbox__3nHLB"};